import React, { useEffect, useState } from "react";
import axios from "axios";
import globalVariables from "../../../GlobalVariable";

const UrlVideos = ({ selectedBusiness, setSelectedBusiness }) => {
  const [videos, setVideos] = useState([
    { serviceType: "", url: "", file: null, isUploaded: false },
  ]);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [submitStatus, setSubmitStatus] = useState(null);

  const loadVideosFromBusiness = async () => {
    console.log(selectedBusiness, "selectedBusiness");
    if (
      selectedBusiness?.videos &&
      typeof selectedBusiness.videos === "object"
    ) {
      const parsedVideos = Object.entries(selectedBusiness.videos).map(
        ([serviceType, url]) => ({
          serviceType,
          url,
          file: null,
          isUploaded: true,
        })
      );
      setVideos(parsedVideos);
      setSubmitStatus("Videos reloaded from saved data.");
      setTimeout(() => setSubmitStatus(null), 3000);
    }
  };

  const getBusiness = async () => {
    try {
      const response = await axios.get(
        `${globalVariables.domain}/business/${selectedBusiness.business_yelp_id}`
      );
      const updatedBusiness = response.data.content;
      setSelectedBusiness(updatedBusiness);

      // actualizar videos con datos actuales
      if (
        updatedBusiness?.videos &&
        typeof updatedBusiness.videos === "object"
      ) {
        const parsedVideos = Object.entries(updatedBusiness.videos).map(
          ([serviceType, url]) => ({
            serviceType,
            url,
            file: null,
            isUploaded: true,
          })
        );
        setVideos(parsedVideos);
        setSubmitStatus("Videos reloaded from latest data.");
        setTimeout(() => setSubmitStatus(null), 3000);
      } else {
        setVideos([]); // si no hay videos
      }
    } catch (error) {
      console.error("Error fetching business:", error);
    }
  };

  useEffect(() => {
    loadVideosFromBusiness();
  }, [selectedBusiness]);

  const handleChange = (index, field, value) => {
    const updatedVideos = [...videos];
    updatedVideos[index][field] = value;
    if (field === "url" && value) {
      updatedVideos[index].isUploaded = true;
    }
    setVideos(updatedVideos);
  };

  const handleAdd = () => {
    setVideos([
      ...videos,
      { serviceType: "", url: "", file: null, isUploaded: false },
    ]);
  };

  const handleRemoveLast = () => {
    if (videos.length > 0) {
      setVideos(videos.slice(0, -1));
    }
  };

  const handleDeleteLine = (indexToRemove) => {
    const updatedVideos = videos.filter((_, index) => index !== indexToRemove);
    setVideos(updatedVideos);
  };

  const handleSelectFile = (index, file) => {
    const updated = [...videos];
    updated[index].file = file;
    updated[index].isUploaded = false;
    setVideos(updated);
  };

  const handleUpload = async (index) => {
    const file = videos[index]?.file;
    if (!file) return alert("No file selected.");

    const formData = new FormData();
    formData.append("file", file);

    setUploadStatus("Uploading...");

    try {
      const response = await axios.post(
        "https://api.samedayvet.com/file",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.success) {
        const videoUrl = response.data.content[0];
        const updated = [...videos];
        updated[index].url = videoUrl;
        updated[index].isUploaded = true;
        setVideos(updated);
        setUploadStatus("Upload successful!");
      } else {
        setUploadStatus("Upload failed. Try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      setUploadStatus("Upload failed. Try again.");
    }

    setTimeout(() => setUploadStatus(null), 3000);
  };

  const handleSubmit = async () => {
    const isValid = videos.every(
      (video) => video.serviceType.trim() !== "" && video.url.trim() !== ""
    );

    if (!isValid) {
      alert("All service types and video URLs must be filled out.");
      return;
    }

    const formattedVideos = videos.reduce((acc, video) => {
      acc[video.serviceType] = video.url;
      return acc;
    }, {});

    try {
      const response = await axios.patch(
        `${globalVariables.domain}/business/${selectedBusiness.business_yelp_id}`,
        {
          videos: formattedVideos,
        }
      );

      console.log("Response:", response.data);
      setSubmitStatus("All videos successfully submitted!");
    } catch (error) {
      console.error(error);
      setSubmitStatus("There was an error submitting the videos.");
    }

    setTimeout(() => setSubmitStatus(null), 3000);
  };

  return (
    <div className="flex flex-grow flex-col p-4">
      <h2 className="text-2xl font-bold mb-4">Create URL Videos</h2>

      <h3 className="text-lg font-semibold mb-4 border-b pb-2">
        {selectedBusiness.business_name}
      </h3>

      <div className="flex justify-between items-center mb-4 flex-wrap gap-4">
        {/* Izquierda: Add, Remove, Refresh */}
        <div className="flex gap-4">
          <button
            onClick={handleAdd}
            className="text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded"
          >
            + Add
          </button>
          <button
            onClick={handleRemoveLast}
            className="text-white bg-red-600 hover:bg-red-700 px-4 py-2 rounded"
            disabled={videos.length === 0}
          >
            − Remove last
          </button>
          <button
            onClick={getBusiness}
            className="text-white bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded"
          >
            ⟳ Refresh
          </button>
        </div>

        {/* Derecha: Submit */}
        <button
          onClick={handleSubmit}
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
        >
          Submit
        </button>
      </div>

      <div className="bg-white rounded-lg p-4 space-y-4 mb-4">
        {videos.map((video, index) => (
          <div
            key={index}
            className="flex flex-row flex-wrap items-center gap-2 w-full"
          >
            <input
              type="text"
              placeholder="Service type"
              value={video.serviceType}
              onChange={(e) =>
                handleChange(index, "serviceType", e.target.value)
              }
              className="border p-2 rounded w-[140px] flex-shrink-0"
            />
            <input
              type="text"
              placeholder="Video URL"
              value={video.url}
              onChange={(e) => handleChange(index, "url", e.target.value)}
              className="border p-2 rounded flex-1 min-w-[180px]"
            />

            {!video.url && (
              <label className="cursor-pointer bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded whitespace-nowrap">
                Select
                <input
                  type="file"
                  accept="video/*"
                  onChange={(e) => handleSelectFile(index, e.target.files[0])}
                  className="hidden"
                />
              </label>
            )}

            {video.file && !video.isUploaded && (
              <button
                onClick={() => handleUpload(index)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded whitespace-nowrap"
              >
                Upload
              </button>
            )}

            <button
              onClick={() => handleDeleteLine(index)}
              className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded"
            >
              🗑️
            </button>
          </div>
        ))}
      </div>

      {/* Notificaciones */}
      {uploadStatus && (
        <p className="text-center text-green-600">{uploadStatus}</p>
      )}
      {submitStatus && (
        <p className="text-center text-green-700">{submitStatus}</p>
      )}
    </div>
  );
};

export default UrlVideos;
